/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * Hint about what type of survey item comes next, for UI skeleton optimization.
 */
export type NextSurveyItemTypeHint = typeof NextSurveyItemTypeHint[keyof typeof NextSurveyItemTypeHint];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NextSurveyItemTypeHint = {
  alwaysInterstitial: 'alwaysInterstitial',
  alwaysQuestion: 'alwaysQuestion',
  dependsOnResponse: 'dependsOnResponse',
} as const;
